<template>
    <div class="cert-page relative px-6 pt-6 pb-20">
        <div class="flex flex-col items-center">
            <div class="w-full flex items-center justify-between">
                <img class="h-6" v-if="player?.logo" :src="player.logo" />
                <div
                    class="relative overflow-hidden py-1 px-3 rounded-full text-xs sm:text-sm font-medium bg-gray-100 text-gray-500"
                >
                    <span>{{ formattedDate }}</span>
                </div>
            </div>
            <div
                v-if="certContent?.courseImage"
                class="h-20 w-20 mx-auto mt-12 bg-white shadow-xl rounded-2xl overflow-hidden"
            >
                <img :src="certContent?.courseImage" alt="cert" />
            </div>
            <div
                class="text-center space-y-3"
                :class="[certContent?.courseImage ? 'mt-8' : 'mt-20']"
            >
                <h2 class="text-gray-700 font-semibold text-4xl">
                    {{ certContent?.courseName }}
                </h2>
                <p class="text-gray-500 font-semibold text-3xl">
                    {{ issuedCert?.userName }}
                </p>
            </div>
            <div
                class="inline-block mt-10 py-3 px-8 rounded-full bg-gray-700 text-white text-lg ring-4 ring-gray-300"
            >
                🏆 {{ $t("r_player.certificate.certified") }}
            </div>
        </div>
    </div>
</template>

<script>
import { i18n } from "@/i18n";
import moment from "moment";

export default {
    props: {
        certContent: {
            type: Object,
            default: () => ({}),
        },
        issuedCert: {
            type: Object,
            required: true,
        },
        player: {
            type: Object,
            required: true,
        },
    },
    computed: {
        formattedDate() {
            return this.issuedCert?.createdAt
                ? moment(this.issuedCert?.createdAt)
                      .locale(i18n.global.locale.value)
                      .format("DD.MM.YYYY")
                : "";
        },
    },
};
</script>

<style scoped>
.cert-page {
    background: url("@/views/tools/player/assets/certs-back.png");
    background-size: cover;
}
</style>
